import MyDishDetails from "../components/my-kitchen/MyDishDetails";

export default {
  name: "My dish",
  component: MyDishDetails,
  url: "/my-kitchen/dish/:id/:slug",
  exact: true,
  requireAuth: true
};
